import { Component, OnInit } from "@angular/core";
import {
    FormControl,
    ReactiveFormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import PasswordConfirm from "./../../../_app-core/_utils/password-match";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";

@Component({
    selector: "app-change-password",
    templateUrl: "./change-password.component.html",
    styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
    isLoading = false;
    isError = false;
    responseData: any;

    passwordData = new FormGroup(
        {
            oldPassword: new FormControl(null, Validators.required),
            newPassword: new FormControl(null, [
                Validators.required,
                Validators.minLength(8),
                Validators.maxLength(15),
                // Validators.pattern(
                //   '^(?=.*[0-9])(?=.*[a-z])(?=.*[*.!@$%^&(){}[]:;<>,.?/~_+-=|]).{8}$'
                // ),
            ]),
            confirmPassword: new FormControl(null, Validators.required),
        },
        {
            validators: [
                PasswordConfirm.match("newPassword", "confirmPassword"),
            ],
        }
    );

    constructor(
        private router: Router,
        private http: HttpClient,
        private authService: AuthService
    ) {}

    passwordChange() {
        const userData = {
            userName: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
            password: this.passwordData.value.oldPassword,
            newPassword: this.passwordData.value.newPassword,
        };

        this.isLoading = true;

        this.authService.changePassword(userData).subscribe(
            (res) => {
                this.isLoading = false;
                this.responseData = res;
                if (this.responseData.status == "success") {
                    console.log("Success");
                    this.router.navigateByUrl("/dashboard");
                } else {
                    this.isError = true;
                    console.log("error response body");
                }
            },
            (error) => {
                console.log("Error");
            }
        );
        //console.log(userData);
    }

    ngOnInit(): void {}
}
